import React, {PropTypes} from 'react';

class SelectionShow extends React.Component {

  constructor () {
    super();
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
  }

  add() {
    let areaId = this.props.areaId;
    this.props.selectionActions.addAreaToSelection(areaId);
  }

  remove() {
    let areaId = this.props.areaId;
    this.props.selectionActions.removeAreaFromSelection(areaId);
  }

  render() {
    let areaId = this.props.areaId;
    let selection = this.props.selection.area_ids;
    let link;
    // Variable to make the difference between InfoBox and Selection
    let is_selection = (this.props.selection.infobox_area_id != 0);

    // Remove label
    let removeLabel = 'Remove';
    if (is_selection) removeLabel += ' from selection';

    // If we have this area in the current selection
    if(selection.indexOf(areaId) > -1) {
      link = <a className="btn btn-default btn-xs" onClick={this.remove} role="button">{removeLabel}</a>;
    }
    else {
      link = <a className="btn btn-default btn-xs" onClick={this.add} role="button">+ Add to selection</a>;
    }

    return (
      <span>
        {link}
      </span>
    );
  }
}

SelectionShow.propTypes = {
  areaId: PropTypes.string.isRequired,
  selection: PropTypes.object.isRequired,
  selectionActions: PropTypes.object.isRequired
};

export default SelectionShow;



/** WEBPACK FOOTER **
 ** ./src/components/SelectionAdd.js
 **/